module.exports = __webpack_public_path__ + "img/wild_table.6cedba92.png";